import React from 'react';
import { useLocation } from 'react-router-dom';
import Footer from '../Component/Footer';
import Navbar from '../Component/Navbar';

export default function RouteWrapper({ childComponent }) {
    const location = useLocation();

    return (
        location.pathname !== '/' && location.pathname !== '/AdminLogin' && location.pathname !== '/ForgotPass' && location.pathname !== '/Dashboard' && location.pathname !== '/Booking' && location.pathname !== '/Leads'  && location.pathname !== '/OfcBearer' && location.pathname !== '/ExeMember' && location.pathname !== '/AddAbout' && location.pathname !== '/ContactAdmin' && location.pathname !== '/NearBy' && location.pathname !== '/GuruList' && location.pathname !== '/Users' && location.pathname !== '/Function'?
            <div className='container-fluid p-0'>
                <div className='row g-0'>
                        <Navbar />
                          {childComponent}
                        <Footer />
                    </div>
                </div>
            :
            childComponent
    )
}